import styled from 'styled-components';

export const Row = styled.div`
  display: block;
  width: 100%;
  margin-top: 20px;
  column-gap: 2%;

  @media (min-width: 1024px) {
    display: flex;
  }
`;
